import React from 'react';

export default function Loader() {
  return (
    <div
      className="spinner-border"
      style={{ width: '4rem', height: '4rem' }}
      role="status"
    ></div>
  );
}
